import gql from 'graphql-tag';

export const REMOVE_NEW_TAG_FROM_ARTICLE_MUTATION = gql`
  mutation RemoveNewTag($articleId: Int!) {
    deleteArticleNotification(articleId: $articleId)
  }
`;
export const REMOVE_NEW_TAG_FROM_EVENT_MUTATION = gql`
  mutation RemoveNewTag($eventId: Int!) {
    deleteEventNotification(eventId: $eventId)
  }
`;

export const UPDATE_ARTICLE_LIKES = gql`
  mutation ArticleLikes($aemId: String!) {
    sendFeedback(aemId: $aemId) {
      likes
    }
  }
`;
export const DELETE_COMPANY = gql`
  mutation deleteCompanyMutation($deleteCompanyInput: DeleteCompanyInput!) {
    deleteCompany(deleteCompanyInput: $deleteCompanyInput) {
      status
    }
  }
`;

export const SEND_ARTICLE_FEEDBACK = gql`
  mutation ArticleFeedback($aemId: String!, $email: String!, $message: String!, $name: String!) {
    sendFeedback(aemId: $aemId, feedback: { email: $email, message: $message, name: $name }) {
      id
      likes
    }
  }
`;

export const SET_SUBSCRIPTION_STATUS_MUTATION = gql`
  mutation setSubscriptionStatus($status: Boolean!) {
    setSubscriptionStatus(status: $status) {
      status
    }
  }
`;

export const UNREGISTER_FROM_EVENT_MUTATION = gql`
  mutation UnregisterFromEvent(
    $eventId: Int!
    $unregister: Boolean
    $participants: [EventParticipantInput!]!
  ) {
    setParticipants(eventId: $eventId, unregister: $unregister, participants: $participants) {
      participants {
        firstName
        lastName
      }
    }
  }
`;

export const SET_PARTICIPANTS_MUTATION = gql`
  mutation SetParticipants(
    $eventId: Int!
    $participants: [EventParticipantInput!]!
    $unregister: Boolean
  ) {
    setParticipants(eventId: $eventId, unregister: $unregister, participants: $participants) {
      participants {
        id
        firstName
        lastName
        fachkraftId
      }
    }
  }
`;

export const SEND_DEB_FORM = gql`
  mutation SendDebForm($debInput: DEBInput!) {
    deb(debInput: $debInput) {
      status
    }
  }
`;

export const UPDATE_INSTALLER_CONSENT_MUTATION = gql`
  mutation updateInstallerConsent($input: InstallerConsentInput!) {
    updateInstallerConsent(input: $input) {
      zuAdressveroeff
      zuInfoversand
      status
    }
  }
`;

export const UPDATE_EXPERT_CONSENT_MUTATION = gql`
  mutation updateExpertConsent($expertEgcid: String!, $input: ExpertConsentInput!) {
    updateExpertConsent(expertEgcid: $expertEgcid, input: $input) {
      zuInfoversand
      status
    }
  }
`;

export const UNREGISTER_EXPERT_MUTATION = gql`
  mutation UnregisterExpert($expertId: Int!) {
    unregisterFachkraft(expertId: $expertId) {
      id
      vorname
      nachname
      ausgeschieden
      bAnrede {
        name
      }
    }
  }
`;

export const REGISTER_EXPERT_MUTATION = gql`
  mutation RegisterFachkraft($expertId: Int!, $email: String) {
    registerFachkraft(expertId: $expertId, email: $email) {
      id
      nachname
      vorname
      status
    }
  }
`;

export const UPDATE_CONTACTS_MUTATION = gql`
  mutation UpdateInstallerExpertTelephoneEmail($input: UpdateInstallerExpertTelephoneEmailInput!) {
    updateInstallerExpertTelephoneEmail(input: $input) {
      status
    }
  }
`;

// PUBLIC mutations which need no authentication config (see Apollo.jsx)

export const PUBLIC_SEND_NE_FORM = gql`
  mutation SendNeForm($neInput: NEInput!) {
    ne(neInput: $neInput) {
      status
    }
  }
`;

export const UPLOAD_ANTRAG_FILE_MUTATION = gql`
  mutation UploadAntragFile($antragId: Long!, $file: FileUpload!) {
    uploadAntragFile(antragId: $antragId, file: $file) {
      id
    }
  }
`;

export const SEND_ANTRAG_MESSAGE_MUTATION = gql`
  mutation SendAntragMessage($antragId: Long!, $input: SendAntragMessageInput!) {
    sendAntragMessage(antragId: $antragId, input: $input) {
      id
      message
      sender
      timestamp
      fields {
        id
        intent
        entity
        entityId
        field
        value
      }
      files {
        id
        intent
        documentType
        file {
          id
          filename
          extension
          deleted
          downloadUrl
        }
      }
      attachments {
        id
        file {
          id
          filename
          extension
          deleted
          downloadUrl
        }
      }
    }
  }
`;

export const VALIDATE_PARTICIPATION_CODE_MUTATION = gql`
  mutation validateAttendance($eventId: Int!, $participationCode: Int!) {
    validateAttendance(eventId: $eventId, participationCode: $participationCode) {
      success
    }
  }
`;
